<template>
  <div class="tags-panel">
    <h3 class="tags-panel__title">Etiquetas Dinámicas</h3>
    <p class="tags-panel__description">
      Haz clic en una etiqueta para insertarla en el editor
    </p>
    <div class="tags-list">
      <button
        v-for="etiqueta in etiquetas"
        :key="etiqueta.tag"
        class="tag-button"
        @click="$emit('tag-selected', etiqueta.tag)"
        type="button"
      >
        <div class="tag-code">{{ etiqueta.tag }}</div>
        <div class="tag-desc">{{ etiqueta.descripcion }}</div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagsPanel',
  data() {
    return {
      etiquetas: [
        { tag: '{CLIENTE_NOMBRE}', descripcion: 'Nombre del cliente' },
        { tag: '{CLIENTE_APELLIDO}', descripcion: 'Apellido del cliente' },
        { tag: '{OT}', descripcion: 'Número de OT' },
        { tag: '{OT_LINK}', descripcion: 'Link a la OT' },
        { tag: '{SERIAL_NUMBER}', descripcion: 'Número de serie' },
        { tag: '{FECHA_INGRESO}', descripcion: 'Fecha de ingreso (DD/MM/YYYY)' },
        { tag: '{FECHA_COMPRA}', descripcion: 'Fecha de compra (DD/MM/YYYY)' },
        { tag: '{FECHA_CIERRE}', descripcion: 'Fecha de cierre (DD/MM/YYYY)' }
      ]
    };
  }
};
</script>

<style scoped>
.tags-panel {
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 20px;
  position: sticky;
  top: 20px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
}

.tags-panel__title {
  font-size: 16px;
  font-weight: 600;
  color: #23201C;
  margin: 0 0 8px 0;
}

.tags-panel__description {
  font-size: 13px;
  color: #525252;
  margin: 0 0 16px 0;
  line-height: 1.4;
}

.tags-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tag-button {
  background: rgba(29, 78, 216, 0.25);
  border: 1px solid #001c6b;
  color: #1d4ed8;
  padding: 10px 12px;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  width: 100%;
}

.tag-button:hover {
  background: rgba(29, 78, 216, 0.35);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.tag-button:active {
  transform: translateY(0);
}

.tag-code {
  font-family: 'Courier New', Courier, monospace;
  font-size: 13px;
  font-weight: 600;
  color: #001c6b;
  margin-bottom: 4px;
  word-break: break-all;
}

.tag-desc {
  font-size: 12px;
  color: #1d4ed8;
  line-height: 1.3;
}
</style>
